import React, { useState, useEffect } from "react";
import axios from "axios";
import SaveIcon from "@material-ui/icons/Save";
import Button from "@material-ui/core/Button";
import DeleteIcon from "@material-ui/icons/Delete";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import CloudUploadOutlinedIcon from "@material-ui/icons/CloudUploadOutlined";

import Input from "../../components/Control/Input";
import { Wrapper } from "../../components/Control/Flexbox";
import PdfImage from "../../images/pdf.png";
import Loader from "../../components/Control/Loader";

const CutomerDrawingInputs = ({
  partId,
  currentId,
  setOpenModal,
  partDesc,
}) => {
  const [uploadFiles, setUploadFiles] = useState({
    file: null,
  });
  const [preview, setPreview] = useState();
  const [isLoading, setIsloading] = useState(false);
  const [customerDrawingData, setCutomerDrawingData] = useState({
    part_name: partDesc?.part_name,
    part_number: partDesc?.part_number,
  });
  const [render, setRender] = useState(false);

  useEffect(() => {
    if (!currentId) return;
    axios(`/api/getOneCutomerDrawing/data/${currentId}`)
      .then((res) => {
        setCutomerDrawingData(res.data);
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsloading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, [isLoading]);

  useEffect(() => {
    if (!uploadFiles.file) return;
    setPreview(URL.createObjectURL(uploadFiles.file));
    return () => {
      URL.revokeObjectURL(uploadFiles.file);
    };
  }, [uploadFiles]);

  const handleImagePdf = (e) => {
    setUploadFiles({
      file: e.target.files[0],
    });
    e.target.value = "";
    setIsloading(true);
  };

  const removeFiles = () => {
    setUploadFiles({
      file: null,
    });
    setPreview(null);
    customerDrawingData.cutomerDrawingFiles = null;
  };

  const handleDrawingData = (e) => {
    customerDrawingData[e.target.name] = e.target.value;
    setRender((prev) => !prev);
  };

  const handleSubmit = () => {
    const formData = new FormData();
    formData.append("part_id", partId);
    formData.append("customer_name", customerDrawingData.customer_name);
    formData.append("drawing_desc", customerDrawingData.drawing_desc);

    if (customerDrawingData._id) {
      formData.append(
        "cutomerDrawingFiles",
        uploadFiles.file || customerDrawingData.cutomerDrawingFiles
      );
      axios
        .put(`/api/updateCutomerDrawing/data/${currentId}`, formData)
        .then((res) => {
          setOpenModal(false);
        })
        .catch((err) => console.log(err));
    } else {
      formData.append("cutomerDrawingFiles", uploadFiles.file);
      axios
        .post(`/api/customerDrawing/create`, formData)
        .then((res) => {
          alert("success");
          setOpenModal(false);
        })
        .catch((err) => console.log(err));
    }
  };
  const ShowPdf = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "2rem 0 0.5rem 0",
          filter: "drop-shadow(10px 10px 5px #868e96)",
        }}
      >
        <img src={PdfImage} height="250px" width="250px" />
      </div>
    );
  };

  return (
    <div>
      <Wrapper style={{ marginTop: "1rem" }}>
        <div>
          <Input
            label="Drawing Description"
            name="drawing_desc"
            type="text"
            onChange={handleDrawingData}
            value={customerDrawingData.drawing_desc}
            defaultValue={customerDrawingData.drawing_desc}
          />
        </div>
        <div>
          <Input
            label="Customer Name"
            name="customer_name"
            type="text"
            onChange={handleDrawingData}
            defaultValue={customerDrawingData.customer_name}
            value={customerDrawingData.customer_name}
          />
        </div>

        <div>
          <Input
            label="Part Number"
            name="part_number"
            type="text"
            defaultValue={partDesc.part_number}
            inputProps={{ readOnly: true }}
          />
        </div>
        <div>
          <Input
            label="Part Description"
            name="part_name"
            type="text"
            // onChange={handleDrawingData}
            defaultValue={customerDrawingData.part_name}
            inputProps={{ readOnly: true }}
          />
        </div>
      </Wrapper>

      <Wrapper style={{ justifyContent: "center" }}>
        <div>
          {isLoading ? (
            <Loader height={"20vh"} />
          ) : (
            <>
              {uploadFiles.file &&
                uploadFiles.file?.type === "application/pdf" && <ShowPdf />}
              {preview ? (
                uploadFiles.file.type !== "application/pdf" && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      padding: "2rem 0 0rem 0",
                    }}
                  >
                    <img
                      src={preview ? preview : ""}
                      alt=""
                      height="auto"
                      width="50%"
                    />
                  </div>
                )
              ) : (
                <>
                  {customerDrawingData?.cutomerDrawingFiles &&
                  customerDrawingData.cutomerDrawingFiles.slice(-3) ===
                    "pdf" ? (
                    <ShowPdf />
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        padding: "2rem 0 0rem 0",
                      }}
                    >
                      {customerDrawingData?.cutomerDrawingFiles &&
                      customerDrawingData?.cutomerDrawingFiles !== "null" ? (
                        <div
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          <img
                            src={customerDrawingData?.cutomerDrawingFiles}
                            alt=""
                            height="auto"
                            width="50%"
                          />
                        </div>
                      ) : (
                        <CloudUploadOutlinedIcon
                          style={{ fontSize: "105px", color: "#868e96" }}
                        />
                      )}
                    </div>
                  )}
                </>
              )}
            </>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "1.2rem",
            }}
          >
            <input
              id="contained-button-file"
              type="file"
              name="pcs_imageOrPdf"
              accept="image/png,image/jpeg,image/jpg/,application/pdf"
              onChange={handleImagePdf}
              hidden
            />
            <label
              htmlFor="contained-button-file"
              style={{
                marginBottom: "0",
              }}
            >
              <Button variant="outlined" component="span" color="secondary">
                <CloudUploadIcon style={{ marginRight: "1rem" }} />
                Upload Picture / Pdf
              </Button>
            </label>
            {(uploadFiles.file || customerDrawingData.cutomerDrawingFiles) && (
              <Button
                variant="outlined"
                type="button"
                color="primary"
                style={{
                  marginLeft: "0.6rem",
                }}
                onClick={removeFiles}
                startIcon={<DeleteIcon />}
              >
                REMOVE
              </Button>
            )}
          </div>
        </div>
      </Wrapper>

      <div
        className="btn_save"
        style={{
          position: "absolute",
          right: "150px",
          top: "9px",
        }}
      >
        <Button
          type="submit"
          variant="outlined"
          color="white"
          size="large"
          style={{ color: "#e9e9e9" }}
          startIcon={<SaveIcon />}
          onClick={handleSubmit}
        >
          Submit
        </Button>
      </div>
    </div>
  );
};

export default CutomerDrawingInputs;
